import { INTERACTION, LAYER_IDS } from '@tmapy/config';
export const NOTES_SAVE_START = '@notes/SAVE_START';
export const NOTES_SAVE_SUCCESS = '@notes/SAVE_SUCCESS';
export const NOTES_SAVE_FAILURE = '@notes/NOTES_SAVE_FAILURE';
export const NOTES_SET_STATE = '@notes/SET_STATE';
export const NOTE_HASH_PARAM_NAME = 'note';
export const ACTION_INTERACTION_MODIFY = {
    type: INTERACTION.SELECT_MODIFY,
    layerId: LAYER_IDS.NOTES,
    style: 'NOTE.active',
};
//# sourceMappingURL=constants.js.map